import { v1Client } from './v1Client'

/**
 * Post a client-resolved tool result back to a conversation. Returns the raw
 * Response — it does NOT throw on a non-OK status, so callers must check
 * `response.ok`.
 */
export const postToolResponse = async ({
  accessToken,
  conversationId,
  toolCallId,
  toolResponse,
}: {
  accessToken: string
  conversationId: string
  toolCallId: string
  toolResponse: string
}) => {
  const { response } = await v1Client.POST('/conversations/{id}/messages', {
    params: { path: { id: conversationId } },
    headers: { Authorization: `Bearer ${accessToken}` },
    body: {
      role: 'tool',
      toolCallId,
      content: toolResponse,
    },
  })
  return response
}
